module.exports = __webpack_public_path__ + "static/img/01.e40b51e.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/03/3/01.png
// module id = P4tO
// module chunks = 2